import getAPIPath from '../modules/api-location';

const enquire = require('enquire');
const owlcarousel = require('owlcarousel');
const notification = require('notification');
const loader = require('loader');


// Locker overview carousel
const lockerOverview = (function() {
  const $lockerOverview = $('.locker-overview-container .carousel-container');
  const owlClass = 'owl-carousel';
  const $generateClubBtn = $('#generate-club');

  const buildCarousel = function() {
    if (!$lockerOverview.hasClass(owlClass)) {
      $lockerOverview.addClass(owlClass);

      $('.owl-carousel').owlCarousel({
        items: 1,
        loop: false,
        dots: true,
        mouseDrag: true,
        autoHeight: true,
      });
    }
  };


  const destroyCarousel = function() {
    $('.owl-carousel').trigger('destroy.owl.carousel');
    $lockerOverview.removeClass(owlClass);
  };


  const resize = function() {
    enquire.register('screen and (max-width: 992px)', {
      match() {
        buildCarousel();
      },
      unmatch() {
        destroyCarousel();
      },
    });
  };


  const viewActivityFeedClick = function() {
    $('.locker-overview-activity-feed .view-all-cta').on('click', function(e) {
      e.preventDefault();
      $('#activity-feed-panel').trigger('click');
    });
  };


  const handleGenerateClubClick = (res) => {
    if (res.statusCode === 200) {
      location.reload();
    } else {
      $('window').notification({
        title: res.message,
        error: true,
      });
    }
  };


  const generateClubClick = () => {
    $generateClubBtn.on('click', function(e) {
      e.preventDefault();
      $('window').btnLoader($(this), {
        dark: true,
      });

      $.ajax({
        url: `${getAPIPath}commandapi/team/generate`,
        type: 'put',
        success: handleGenerateClubClick,
        async: true,
        xhrFields: {
          withCredentials: true,
        },
      });
    });
  };


  const init = function() {
    if ($lockerOverview.length) {
      resize();
      viewActivityFeedClick();
    }

    if ($generateClubBtn.length) {
      generateClubClick();
    }
  };

  return {
    init,
  };
}());

lockerOverview.init();



// WEBPACK FOOTER //
// ./library/js/modules/locker.js